import React, { useEffect, useState, useRef } from "react";
import "../css/post.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import { API_URL_All } from "../api";
import { useNavigate } from "react-router-dom";

const ServicesPage = () => {
  const navigate = useNavigate();
  const [posts, setServices] = useState([]);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API_URL_All}/api/posts/`);
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  function convertToSlug(text) {
    return text
      .toLowerCase() // viết thường
      .normalize("NFD") // tách dấu khỏi ký tự
      .replace(/[\u0300-\u036f]/g, "") // xóa dấu
      .replace(/[^a-z0-9\s-]/g, "") // xóa ký tự đặc biệt
      .trim() // bỏ khoảng trắng đầu/cuối
      .replace(/\s+/g, "-"); // thay khoảng trắng bằng dấu gạch ngang
  }

  return (
    <div>
      <Header />
      <div className="container-fluid p-0">
        <div className="container">
          <div className="col-md-12">
            <div className="service-section">
              <div className="row mt-2">
                {posts.map((post) => (
                  <div key={post.id} className="col-md-4 mb-4">
                    <div className="d-flex flex-column post-card" onClick={() => navigate(`/posts/${post.id}/${convertToSlug(post.link)}`)}>
                      <img
                        src={post.mainImageUrl}
                        alt={post.title}
                        className="img-fluid post-main-image"
                      />
                      <div className="card-body p-2">
                        <div className="card-title post-title ellipsis-multiline ellipsis-multiline-3-row">
                          {post.title}
                        </div>
                        <div className="post-description ellipsis-multiline ellipsis-multiline-2-row">
                          {post.description}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
